import {
  CLEAR_R_N_M,
  MOSCOW_SCENARIO_CLEAR_REGION,
  R_N_M_FIFTH_STEP_LOADING_FAILED,
  R_N_M_FIFTH_STEP_LOADING_SUCCESS,
  R_N_M_FIRST_STEP_LOADING_FAILED,
  R_N_M_FIRST_STEP_LOADING_SUCCESS,
  R_N_M_FOURTH_STEP_LOADING_FAILED,
  R_N_M_FOURTH_STEP_LOADING_STARTED,
  R_N_M_FOURTH_STEP_LOADING_SUCCESS,
  R_N_M_SECOND_STEP_LOADING_FAILED,
  R_N_M_SECOND_STEP_LOADING_SUCCESS,
  R_N_M_SIXTH_STEP_LOADING_FAILED,
  R_N_M_SIXTH_STEP_LOADING_SUCCESS,
  R_N_M_THIRD_STEP_LOADING_FAILED,
  R_N_M_THIRD_STEP_LOADING_SUCCESS,
  SELECT_MEDICAL_ORGANISATION,
  SELECT_REGION,
  SET_DEFAULT_VALUE,
  RESTART_STEPS,
  SET_ERROR_MESSAGE,
  CLEAN_ERROR_MESSAGE, R_N_M_FIFTH_STEP_LOADING_FAILED_WITH_MESSAGE, DETECT_REGION
} from "../actions/types";

const steps = {
  firstStepSuccess: false,
  secondStepLoadingSuccess: false,
  thirdStepLoadingSuccess: false,
  fourthStepLoadingSuccess: false,
  fifthStepLoadingSuccess: false,
  sixthStepLoadingSuccess: false,
};

const defaultStateStartPanel = {
  selectedRegion: "",
  selectedMedicalOrganisation: "",
  medicalOrganisations: [],
  availabilityForRegion: false,
  userChecks: {},
  errorMessage: null,
};

const defaultState = {
  orderId: "",
  regions: [],
  ...steps,
  ...defaultStateStartPanel,
};

const updateRegionsAndMedicalOrganisations = (state, action) => {
  if (!state) {
    return defaultState;
  }
  switch (action.type) {
    case R_N_M_FIRST_STEP_LOADING_SUCCESS:
      return {
        ...state.regionAndMedicalOrganisation,
        orderId: action.payload,
        firstStepSuccess: true,
      };
    case RESTART_STEPS:
      return {
        ...state.regionAndMedicalOrganisation,
        ...defaultStateStartPanel,
      };
    case R_N_M_FIRST_STEP_LOADING_FAILED:
      return {
        ...state.regionAndMedicalOrganisation,
        error: action.payload.error,
      };
    case R_N_M_SECOND_STEP_LOADING_SUCCESS:
      return {
        ...state.regionAndMedicalOrganisation,
        regions: action.payload,
        secondStepLoadingSuccess: true,
      };
    case R_N_M_SECOND_STEP_LOADING_FAILED:
      return {
        ...state.regionAndMedicalOrganisation,
        error: action.payload.error,
      };
    case R_N_M_THIRD_STEP_LOADING_SUCCESS:
      return {
        ...state.regionAndMedicalOrganisation,
        thirdStepLoadingSuccess: true,
        prohibitions: action.payload ? action.payload : [],
      };
    case R_N_M_THIRD_STEP_LOADING_FAILED:
      return {
        ...state.regionAndMedicalOrganisation,
        thirdStepLoadingSuccess: false,
      };
    case R_N_M_FOURTH_STEP_LOADING_STARTED:
      return {
        ...state.regionAndMedicalOrganisation,
        fourthStepLoadingStarted: true,
      };
    case R_N_M_FOURTH_STEP_LOADING_SUCCESS:
      return {
        ...state.regionAndMedicalOrganisation,
        fourthStepLoadingSuccess: true,
        availabilityForRegion: action.payload,
      };
    case R_N_M_FOURTH_STEP_LOADING_FAILED:
      return {
        ...state.regionAndMedicalOrganisation,
        fourthStepLoadingSuccess: false,
        error: action.payload.error,
      };
    case MOSCOW_SCENARIO_CLEAR_REGION:
      return {
        ...state.regionAndMedicalOrganisation,
        userChecks: {},
        medicalOrganisations: [],
        selectedMedicalOrganisation: "",
        selectedRegion: "",
      };
    case R_N_M_FIFTH_STEP_LOADING_SUCCESS:
      return {
        ...state.regionAndMedicalOrganisation,
        fifthStepLoadingSuccess: true,
        userChecks: action.payload,
      };
    case R_N_M_FIFTH_STEP_LOADING_FAILED:
      return {
        ...state.regionAndMedicalOrganisation,
        fifthStepLoadingSuccess: false,
        error: action.payload.error,
      };
    case R_N_M_FIFTH_STEP_LOADING_FAILED_WITH_MESSAGE:
      return {
        ...state.regionAndMedicalOrganisation,
        fifthStepLoadingSuccess: false,
        userChecks: action.payload,
      };
    case R_N_M_SIXTH_STEP_LOADING_SUCCESS:
      return {
        ...state.regionAndMedicalOrganisation,
        sixthStepLoadingSuccess: true,
        medicalOrganisations: action.payload,
      };
    case R_N_M_SIXTH_STEP_LOADING_FAILED:
      return {
        ...state.regionAndMedicalOrganisation,
        sixthStepLoadingSuccess: false,
        error: action.payload.error,
      };
    case DETECT_REGION:
      return {
        ...state.regionAndMedicalOrganisation,
        detectedRegion: action.payload,
      };
    case SELECT_REGION:
      return {
        ...state.regionAndMedicalOrganisation,
        selectedRegion: action.payload,
      };
    case SET_ERROR_MESSAGE:
      return {
        ...state.regionAndMedicalOrganisation,
        errorMessage: action.payload,
      };
    case CLEAN_ERROR_MESSAGE:
      return {
        ...state.regionAndMedicalOrganisation,
        errorMessage: null,
      };
    case SELECT_MEDICAL_ORGANISATION:
      return {
        ...state.regionAndMedicalOrganisation,
        selectedMedicalOrganisation: action.payload,
      };
    case CLEAR_R_N_M:
      return {
        ...defaultState,
        orderId: state.regionAndMedicalOrganisation.orderId,
        regions: state.regionAndMedicalOrganisation.regions,
      };

    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.regionAndMedicalOrganisation,
      };
  }
};

export default updateRegionsAndMedicalOrganisations;
